import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=fd26c402&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=fd26c402&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd26c402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd26c402')) {
      api.createRecord('fd26c402', component.options)
    } else {
      api.reload('fd26c402', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=fd26c402&scoped=true", function () {
      api.rerender('fd26c402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Button.vue"
export default component.exports